export default {
  changeCity (state, city) {
    state.city = city
    try {
      localStorage.city = city
    } catch (e) {}
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js